<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100 sidenav-list-clean"
    id="sidenav-collapse-main"
    v-if="user"
  >
    <!-- USER -->
    <ul class="navbar-nav" v-if="user.role == 'USER'">
      <li class="nav-item mb-1">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          :collapse="false"
          collapseRef="/dashboard"
          navText="Dashboard"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item mb-1">
        <sidenav-collapse
          url="#"
          :collapse="false"
          collapseRef="/plans"
          navText="Planos"
          class="sidenav-premium-item"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5 text-warning">workspace_premium</i>
          </template>
        </sidenav-collapse>
      </li>

      <sidenav-group
        group-id="user-operacao"
        label="Operação"
        icon="bolt"
        :routes="['/raffles', '/orders', '/ranking', '/wallet']"
        :default-open="true"
      >
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/raffles"
            navText="Campanhas"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">confirmation_number</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/orders"
            navText="Histórico de clientes"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">shopping_cart</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/ranking"
            navText="Ranking"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">trending_up</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item" v-if="user.system_wallet != false">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/wallet"
            navText="Carteira"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">account_balance_wallet</i>
            </template>
          </sidenav-collapse>
        </li>
      </sidenav-group>

      <sidenav-group
        group-id="user-ferramentas"
        label="Ferramentas"
        icon="handyman"
        :routes="userFerramentasRoutes"
      >
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/remarketing"
            navText="Remarketing"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5 text-success">campaign</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/trafego"
            navText="Tracking 365"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5 text-info">public</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item" v-if="academyEnabled">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/academy"
            navText="Academy"
            class="sidenav-premium-item"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5 text-warning">workspace_premium</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/tutoriais"
            navText="Tutoriais"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">school</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/sorteador"
            navText="Sorteador"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">casino</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/planejador-365"
            navText="Planejador 365"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">calculate</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/hora-premiada"
            navText="Hora Premiada"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">schedule</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/awarded-quotas"
            navText="Jogos Premiados"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">stars</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/lowest-and-highest"
            navText="Menor e maior cota"
          >
            <template v-slot:icon>
              <i
                class="material-icons-round opacity-10 fs-5"
                style="transform: rotate(-90deg)"
                >compare_arrows</i
              >
            </template>
          </sidenav-collapse>
        </li>
      </sidenav-group>

      <sidenav-group
        group-id="user-crescimento"
        label="Crescimento"
        icon="groups"
        :routes="[
          '/premiacoes',
          '/meus-indicados',
          '/materiais-divulgacao',
          '/minhas-afiliacoes',
          { path: '/settings', query: { tab: 'affiliate' } },
        ]"
      >
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/premiacoes"
            navText="Premiações"
            class="sidenav-premium-item"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5 text-warning">emoji_events</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <router-link
            to="/settings?tab=affiliate"
            class="nav-link sidenav-sublink"
            :class="{
              'is-active':
                $route.path.startsWith('/settings') && $route.query.tab === 'affiliate',
            }"
          >
            <i class="material-icons-round fs-5 me-2">star</i>
            <span class="sidenav-normal text-sm">{{
              user.is_affiliate ? 'Perfil afiliado' : 'Ser afiliado Rifa365'
            }}</span>
          </router-link>
        </li>
        <li class="nav-item" v-if="user.is_affiliate">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/meus-indicados"
            navText="Meus Indicados"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">group</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item" v-if="user.is_affiliate">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/materiais-divulgacao"
            navText="Materiais"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">folder_shared</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/minhas-afiliacoes"
            navText="Afiliado de campanhas"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5 text-warning">handshake</i>
            </template>
          </sidenav-collapse>
        </li>
      </sidenav-group>

      <li class="nav-item mb-1">
        <sidenav-collapse
          url="#"
          :collapse="false"
          collapseRef="/settings"
          navText="Configurações"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">settings</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item mt-3 mb-2 px-2">
        <router-link
          :to="user.is_affiliate ? '/meus-indicados' : '/settings?tab=affiliate'"
          class="sidenav-affiliate-cta"
          style="color: #ffffff !important"
        >
          <span class="sidenav-affiliate-cta__shine" aria-hidden="true"></span>
          <span class="sidenav-affiliate-cta__badge" style="color: #ffffff !important">
            <i class="material-icons" style="color: #ffffff !important">group</i>
            {{ user.is_affiliate ? 'Afiliado' : 'Novo' }}
          </span>
          <span class="sidenav-affiliate-cta__title" style="color: #ffffff !important">
            Seja afiliado.<br />Divulgue e ganhe dinheiro
          </span>
          <span class="sidenav-affiliate-cta__sub" style="color: #ffffff !important">
            {{
              user.is_affiliate
                ? 'Abra seu painel, compartilhe o link e acompanhe as comissões.'
                : 'Indique a Rifa365 e receba comissão na 1ª taxa ou plano.'
            }}
          </span>
          <span class="sidenav-affiliate-cta__action">
            <i class="material-icons">rocket_launch</i>
            {{ user.is_affiliate ? 'Abrir painel' : 'Quero me afiliar' }}
            <i class="material-icons">arrow_forward</i>
          </span>
        </router-link>
      </li>
    </ul>

    <!-- ADMIN -->
    <ul class="navbar-nav" v-if="user.role == 'ADMIN'">
      <li class="nav-item mb-1">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          :collapse="false"
          collapseRef="/dashboard"
          navText="Dashboard"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>

      <sidenav-group
        group-id="admin-operacao"
        label="Operação"
        icon="bolt"
        :routes="[
          '/users',
          '/raffles',
          '/custom-domains',
          '/withdrawals-admin',
          '/plan-payments',
          '/affiliate-withdrawals-admin',
          '/wallet-applications',
        ]"
        :default-open="true"
      >
        <li class="nav-item">
          <sidenav-collapse url="#" :collapse="false" collapseRef="/users" navText="Usuários">
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">person</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse url="#" :collapse="false" collapseRef="/raffles" navText="Campanhas">
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">confirmation_number</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/custom-domains"
            navText="Domínios"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">language</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/withdrawals-admin"
            navText="Saques"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">account_balance_wallet</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/plan-payments"
            navText="PIX de planos"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">receipt_long</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/affiliate-withdrawals-admin"
            navText="Saques afiliados"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">handshake</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/wallet-applications"
            navText="Solicitações de carteira"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">how_to_reg</i>
            </template>
          </sidenav-collapse>
        </li>
      </sidenav-group>

      <sidenav-group
        group-id="admin-marketing"
        label="Marketing"
        icon="campaign"
        :routes="[
          '/coupons',
          '/recovery',
          '/email-broadcast',
          '/tracking',
          '/tracking365',
          '/announcements',
          '/admin/blog',
          '/admin/affiliates',
          '/admin/materiais-divulgacao',
          '/admin/tutoriais',
          '/admin/academy',
        ]"
      >
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/admin/academy"
            navText="Academy"
            class="sidenav-premium-item"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5 text-warning">workspace_premium</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/admin/tutoriais"
            navText="Tutoriais"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">school</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/admin/blog"
            navText="Blog SEO"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">article</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/admin/affiliates"
            navText="Afiliados"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">groups</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/admin/materiais-divulgacao"
            navText="Materiais afiliados"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">folder_shared</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/announcements"
            navText="Novidades"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">campaign</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse url="#" :collapse="false" collapseRef="/coupons" navText="Cupons">
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">local_offer</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/recovery"
            navText="Recuperar cadastros"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">support_agent</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/email-broadcast"
            navText="Disparo de e-mail"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">forward_to_inbox</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse url="#" :collapse="false" collapseRef="/tracking" navText="Tracking">
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">public</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/tracking365"
            navText="Tracking365 Events"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">insights</i>
            </template>
          </sidenav-collapse>
        </li>
      </sidenav-group>

      <sidenav-group
        group-id="admin-ferramentas"
        label="Ferramentas"
        icon="handyman"
        :routes="[
          '/lowest-and-highest',
          '/awarded-quotas',
          '/hora-premiada',
          '/sorteador',
          '/ranking',
          '/orders',
        ]"
      >
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/sorteador"
            navText="Sorteador"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">casino</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/hora-premiada"
            navText="Hora Premiada"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">schedule</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/awarded-quotas"
            navText="Jogos Premiados"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">stars</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/lowest-and-highest"
            navText="Menor e maior cota"
          >
            <template v-slot:icon>
              <i
                class="material-icons-round opacity-10 fs-5"
                style="transform: rotate(-90deg)"
                >compare_arrows</i
              >
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse url="#" :collapse="false" collapseRef="/ranking" navText="Ranking">
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">trending_up</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse url="#" :collapse="false" collapseRef="/orders" navText="Histórico de clientes">
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">shopping_cart</i>
            </template>
          </sidenav-collapse>
        </li>
      </sidenav-group>

      <sidenav-group
        group-id="admin-sistema"
        label="Sistema"
        icon="settings"
        :routes="['/system-logs', '/semaphore-control', '/global-settings', '/legal-documents', '/fiscal-invoices']"
      >
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/global-settings"
            navText="Config. globais"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">tune</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/legal-documents"
            navText="Termos & Privacidade"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">gavel</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/system-logs"
            navText="Logs do sistema"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">assignment</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/fiscal-invoices"
            navText="Notas fiscais"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">description</i>
            </template>
          </sidenav-collapse>
        </li>
        <li class="nav-item">
          <sidenav-collapse
            url="#"
            :collapse="false"
            collapseRef="/semaphore-control"
            navText="Controle semáforo"
          >
            <template v-slot:icon>
              <i class="material-icons-round opacity-10 fs-5">lock_clock</i>
            </template>
          </sidenav-collapse>
        </li>
      </sidenav-group>
    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import SidenavGroup from "./SidenavGroup.vue";
import UsersHttp from "@/http/UsersHttp.js";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  provide() {
    return {
      getSidenavOpenGroup: () => this.openGroupId,
      setSidenavOpenGroup: (id) => {
        this.openGroupId = id;
      },
    };
  },
  data() {
    return {
      user: null,
      openGroupId: null,
      academyEnabled: false,
    };
  },
  computed: {
    userFerramentasRoutes() {
      const routes = [
        "/remarketing",
        "/lowest-and-highest",
        "/awarded-quotas",
        "/hora-premiada",
        "/sorteador",
        "/planejador-365",
        "/tutoriais",
        "/trafego",
      ];
      if (this.academyEnabled) routes.push("/academy");
      return routes;
    },
  },
  components: {
    SidenavCollapse,
    SidenavGroup,
  },
  created() {
    this.user = this.$store.getters.user;
    window.addEventListener("user-updated", this.handleUserUpdate);
    window.addEventListener("rifa365:platform-settings-updated", this.loadAcademyFlag);
    this.loadAcademyFlag();
  },
  beforeUnmount() {
    window.removeEventListener("user-updated", this.handleUserUpdate);
    window.removeEventListener("rifa365:platform-settings-updated", this.loadAcademyFlag);
  },
  methods: {
    handleUserUpdate() {
      this.user = this.$store.getters.user;
    },
    async loadAcademyFlag() {
      try {
        const { data } = await UsersHttp.getGlobalSettings();
        this.academyEnabled = !!data?.academy_enabled;
      } catch {
        this.academyEnabled = false;
      }
    },
  },
};
</script>

<style scoped>
.sidenav-list-clean {
  padding-bottom: 1rem;
}

/* Planos / Premiações / Academy — destaque dourado premium */
:deep(.sidenav-premium-item .nav-link-text) {
  font-weight: 700;
  background: linear-gradient(120deg, #b45309 0%, #f59e0b 45%, #fbbf24 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
:deep(.sidenav-premium-item.active .nav-link-text) {
  background: none;
  -webkit-background-clip: unset;
  background-clip: unset;
  color: #fff !important;
}
:deep(.sidenav-premium-item .material-icons-round.text-warning) {
  color: #f59e0b !important;
  filter: drop-shadow(0 0 6px rgba(245, 158, 11, 0.45));
}


.sidenav-sublink {
  display: flex !important;
  align-items: center;
  border-radius: 10px !important;
  padding: 0.4rem 0.7rem !important;
  color: #344767 !important;
  text-decoration: none !important;
  background: transparent !important;
  box-shadow: none !important;
}
.sidenav-sublink .material-icons-round,
.sidenav-sublink .sidenav-normal {
  color: #344767 !important;
  opacity: 1 !important;
}
.sidenav-sublink:hover {
  background: rgba(52, 71, 103, 0.06) !important;
}
.sidenav-sublink.is-active {
  background: rgba(94, 41, 176, 0.1) !important;
  color: #5e29b0 !important;
}
.sidenav-sublink.is-active .material-icons-round,
.sidenav-sublink.is-active .sidenav-normal {
  color: #5e29b0 !important;
}

.sidenav-affiliate-cta {
  position: relative;
  display: block;
  overflow: hidden;
  isolation: isolate;
  text-decoration: none !important;
  border-radius: 16px;
  padding: 0.9rem 0.85rem 0.95rem;
  color: #ffffff !important;
  background: linear-gradient(145deg, #661cb0 0%, #8b3dd4 45%, #e41b80 100%);
  box-shadow:
    0 8px 22px rgba(102, 28, 176, 0.4),
    0 0 22px rgba(228, 27, 128, 0.35);
  animation: sidenav-aff-pulse 1.8s ease-in-out infinite;
}
.sidenav-affiliate-cta__shine {
  position: absolute;
  top: 0;
  left: 0;
  width: 55%;
  height: 100%;
  pointer-events: none;
  z-index: 3;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.05) 35%,
    rgba(255, 255, 255, 0.55) 50%,
    rgba(255, 255, 255, 0.05) 65%,
    transparent 100%
  );
  animation: sidenav-aff-shimmer 2.2s linear infinite;
}
.sidenav-affiliate-cta:hover,
.sidenav-affiliate-cta:focus,
.sidenav-affiliate-cta:active,
.sidenav-affiliate-cta.router-link-active {
  color: #ffffff !important;
  filter: brightness(1.05);
}
.sidenav-affiliate-cta > *:not(.sidenav-affiliate-cta__shine) {
  position: relative;
  z-index: 2;
  color: #ffffff !important;
}
.sidenav-affiliate-cta .material-icons {
  color: #ffffff !important;
}

.sidenav-affiliate-cta__badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #ffffff !important;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  padding: 0.2rem 0.55rem 0.2rem 0.4rem;
  margin-bottom: 0.5rem;
}
.sidenav-affiliate-cta__badge .material-icons {
  font-size: 13px;
  color: #ffffff !important;
}

.sidenav-affiliate-cta__title {
  display: block;
  font-size: 0.98rem;
  font-weight: 800;
  line-height: 1.25;
  margin-bottom: 0.3rem;
  letter-spacing: -0.01em;
  color: #ffffff !important;
}

.sidenav-affiliate-cta__sub {
  display: block;
  font-size: 0.7rem;
  line-height: 1.4;
  color: #ffffff !important;
  margin-bottom: 0.75rem;
  opacity: 1 !important;
}

.sidenav-affiliate-cta__action {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  width: 100%;
  font-size: 0.78rem;
  font-weight: 800;
  background: #fff;
  color: #4a148c !important;
  border-radius: 10px;
  padding: 0.55rem 0.7rem;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.14);
}
.sidenav-affiliate-cta__action .material-icons {
  font-size: 15px;
  color: #7b23d3 !important;
}
.sidenav-affiliate-cta__action .material-icons:last-child {
  color: #4a148c !important;
  margin-left: auto;
}

@keyframes sidenav-aff-shimmer {
  0% {
    transform: translateX(-140%);
  }
  100% {
    transform: translateX(260%);
  }
}

@keyframes sidenav-aff-pulse {
  0%,
  100% {
    box-shadow:
      0 8px 22px rgba(102, 28, 176, 0.4),
      0 0 14px rgba(228, 27, 128, 0.3);
  }
  50% {
    box-shadow:
      0 12px 30px rgba(102, 28, 176, 0.55),
      0 0 34px rgba(228, 27, 128, 0.55);
  }
}
</style>

<style>
/* Beat Material Dashboard: .sidenav.bg-white * { color: $h-color !important } */
.sidenav.bg-white a.sidenav-affiliate-cta,
.sidenav.bg-white a.sidenav-affiliate-cta *,
.sidenav.bg-transparent a.sidenav-affiliate-cta,
.sidenav.bg-transparent a.sidenav-affiliate-cta *,
#sidenav-main a.sidenav-affiliate-cta,
#sidenav-main a.sidenav-affiliate-cta * {
  color: #ffffff !important;
}
.sidenav.bg-white a.sidenav-affiliate-cta .sidenav-affiliate-cta__action,
.sidenav.bg-white a.sidenav-affiliate-cta .sidenav-affiliate-cta__action *,
.sidenav.bg-transparent a.sidenav-affiliate-cta .sidenav-affiliate-cta__action,
.sidenav.bg-transparent a.sidenav-affiliate-cta .sidenav-affiliate-cta__action *,
#sidenav-main a.sidenav-affiliate-cta .sidenav-affiliate-cta__action,
#sidenav-main a.sidenav-affiliate-cta .sidenav-affiliate-cta__action * {
  color: #4a148c !important;
}
.sidenav.bg-white a.sidenav-affiliate-cta .sidenav-affiliate-cta__action .material-icons:first-child,
.sidenav.bg-transparent a.sidenav-affiliate-cta .sidenav-affiliate-cta__action .material-icons:first-child,
#sidenav-main a.sidenav-affiliate-cta .sidenav-affiliate-cta__action .material-icons:first-child {
  color: #7b23d3 !important;
}

body.dark-version .sidenav:not(.bg-white) .sidenav-sublink,
body.dark-version .sidenav:not(.bg-white) .sidenav-sublink .material-icons-round,
body.dark-version .sidenav:not(.bg-white) .sidenav-sublink .sidenav-normal {
  color: rgba(255, 255, 255, 0.8) !important;
}

body.dark-version .sidenav:not(.bg-white) .sidenav-sublink:hover {
  background: rgba(255, 255, 255, 0.08) !important;
}

body.dark-version .sidenav:not(.bg-white) .sidenav-sublink.is-active {
  background: rgba(124, 58, 237, 0.28) !important;
  color: #fff !important;
}

body.dark-version .sidenav:not(.bg-white) .sidenav-sublink.is-active .material-icons-round,
body.dark-version .sidenav:not(.bg-white) .sidenav-sublink.is-active .sidenav-normal {
  color: #fff !important;
}

body.dark-version .sidenav:not(.bg-white) > .navbar-collapse > .navbar-nav > .nav-item > .nav-link,
body.dark-version .sidenav:not(.bg-white) > .navbar-collapse > .navbar-nav > .nav-item > .nav-link .nav-link-text,
body.dark-version .sidenav:not(.bg-white) > .navbar-collapse > .navbar-nav > .nav-item > .nav-link .material-icons-round {
  color: rgba(255, 255, 255, 0.85) !important;
}

body.dark-version .sidenav:not(.bg-white) .nav-link.active.bg-gradient-primary,
body.dark-version .sidenav:not(.bg-white) .nav-link.active[class*="bg-gradient-"] {
  color: #fff !important;
}
</style>
